var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.197 1.743a.665.665 0 0 0-.94-.94L5 4.06 1.744.803a.665.665 0 0 0-.94.94L4.06 5 .803 8.257a.665.665 0 1 0 .94.94L5 5.94l3.257 3.257a.665.665 0 0 0 .94-.94L5.94 5z"
})));
export default SvgCloseIcon;